var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"back-button",class:_vm.cssClass,on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('img',{attrs:{"src":_vm.imgsrc,"alt":"back","width":"24","height":"12"}})])}
var staticRenderFns = []

export { render, staticRenderFns }